import { $themeBreakpoints } from "@themeConfig";
import axios from "../../libs/axios";
import Vue from "vue";
export default {
    namespaced: true,
    state: {
        windowWidth: 0,
        shallShowOverlay: false,
        user: null,
        roles: [],
        permissions: [],
        modules: [],
        parentUser: null,
        sender_number: "",
        country_iso_selected: null,
        notifications: [],
        pages: {
            carrier_sell: {
                search: ""
            },
            commission: {
                from_date: null,
                to_date: null,
                data: [],
                user_id: ""
            }
        },
        cart: [],
        checkoutDetails: null,
        topup_category_id: null,
    },
    getters: {
        currentBreakPoint: state => {
            const { windowWidth } = state;
            if (windowWidth >= $themeBreakpoints.xl) return "xl";
            if (windowWidth >= $themeBreakpoints.lg) return "lg";
            if (windowWidth >= $themeBreakpoints.md) return "md";
            if (windowWidth >= $themeBreakpoints.sm) return "sm";
            return "xs";
        },
        getUserInfo: state => state.user,
        getPages: state => state.pages,
        GET_SHIPPING_COST(state) {
            let products = state.cart;
            let sum = 0;
            products.forEach(product => {
                let cost = product.shipping_cost;
                if (cost === undefined || cost === null) cost = 0;
                sum += cost * product.quantity;
            });
            return sum;
        },
        GET_TOTAL_ECOMMERCE_ORDER_COST(state, getters) {
            return getters.GET_TOTAL_PRODUCT_COST + getters.GET_SHIPPING_COST;
        },
        GET_ECOMMERCE_CART(state) {
            return state.cart;
        },
        GET_TOTAL_PRODUCT_COST(state) {
            let products = state.cart;
            let sum = 0;
            products.forEach(product => {
                sum += product.price * product.quantity;
            });

            return sum;
        },
        GET_TOTAL_ECOMMERCE_ORDER_COST(state, getters) {
            return getters.GET_TOTAL_PRODUCT_COST + getters.GET_SHIPPING_COST;
        },
        GET_ECOMMERCE_CART(state) {
            return state.cart;
        }
    },
    mutations: {
        UPDATE_WINDOW_WIDTH(state, val) {
            state.windowWidth = val;
        },
        TOGGLE_OVERLAY(state, val) {
            state.shallShowOverlay =
                val !== undefined ? val : !state.shallShowOverlay;
        },
        UPDATE_USER_INFO(state, payload) {
            state.user = payload;
            if (state.user) {
                if (!isNaN(state.user.balance))
                    state.user.balance = parseFloat(state.user.balance).toFixed(
                        2
                    );
            }
        },
        UPDATE_PARENT_USER_INFO(state, payload) {
            state.parentUser = payload;
        },

        USER_SET_TO_DEFAULT(state) {
            if (state.user !== null && state.user.hasOwnProperty("token")) {
                axios.post(
                    "logout",
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${state.user.token}`
                        }
                    }
                );
            }
            state.user = null;
        },
        PARENT_USER_SET_TO_DEFAULT(state) {
            if (
                state.parentUser !== null &&
                state.parentUser.hasOwnProperty("token")
            ) {
                axios.post(
                    "logout",
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${state.parentUser.token}`
                        }
                    }
                );
            }
            state.parentUser = null;
        },
        SET_ALL_PERMISSIONS(state, payload) {
            state.permissions = payload;
        },
        SET_ALL_ROLES(state, payload) {
            state.roles = payload;
        },
        SET_ALL_MODULES(state, payload) {
            state.modules = payload;
        },
        SET_SENDER_NUMBER(state, payload) {
            state.sender_number = payload;
        },
        SET_BALANCE(state, payload) {
            state.user.balance = payload;
        },
        SET_USER_PERMISSIONS(state, payload) {
            if (state.user) state.user.permissions = payload;
        },
        SET_COMMISSION_PAGE_DATA(state, payload) {
            state.pages.commission.data = payload;
        },
        UPDATE_ITEM_CART_QUANTITY(state, payload) {
            const id = payload.id;
            const search_results = state.cart.filter(item => {
                return item.id == id;
            });
            const index = state.cart.findIndex(item => {
                return item.id == id;
            });
            if (search_results.length > 0) {
                const item = search_results[0];
                if (item.quantity === undefined) item.quantity = 1;
                else item.quantity = payload.quantity;
                Vue.set(state.cart, index, item);
            }
        },
        ADD_ITEM_TO_CART(state, payload) {
            const id = payload.id;
            const search_results = state.cart.filter(item => {
                return item.id == id;
            });

            if (search_results.length > 0) {
                const item = search_results[0];
                if (item.quantity === undefined) item.quantity = 1;
                else item.quantity += 1;
            } else {
                payload.quantity = 1;
                state.cart.push(payload);
            }
        },
        REMOVE_ITEM_FROM_CART(state, payload) {
            const id = payload.id;
            const index = state.cart.findIndex(item => {
                return item.id == id;
            });

            if (index > -1) {
                state.cart.splice(index, 1);
            }
        },
        CLEAR_CART(state){
            state.cart = []
        },
        SET_CARRIER_COUNTRY_ISO(state,payload){
          state.country_iso_selected = payload
        },
        SET_CARRIER_SELL_SEARCH(state,payload){
          state.pages.carrier_sell.search = payload
        },
        SET_TOPUP_CATEGORY_ID(state,payload){
          state.topup_category_id = payload
        }
    },
    actions: {
        getUserPermissions({ commit, getters }) {
            const user = getters.getUserInfo;
            if (user && user.token) {
                axios
                    .get("permission/user", {
                        headers: {
                            Authorization: `Bearer ${user.token}`
                        }
                    })
                    .then(response => {
                        commit("SET_USER_PERMISSIONS", response.data.data);
                    });
            }
        },
        updateUserInfo({ commit }, payload) {
            commit("UPDATE_USER_INFO", payload);
        },

        getAllPermissions({ commit }, payload) {
            axios.get("permission").then(response => {
                commit("SET_ALL_PERMISSIONS", response.data.data);
            });
        },
        getAllRoles({ commit }, payload) {
            axios.get("permission/roles").then(response => {
                commit("SET_ALL_ROLES", response.data.data);
            });
        },
        getBalance({ commit, getters }, payload) {
            if (getters.getUserInfo && getters.getUserInfo.token) {
                axios
                    .get("client/user/balance", {
                        headers: {
                            Authorization: `Bearer ${getters.getUserInfo.token}`
                        }
                    })
                    .then(response => {
                        commit("SET_BALANCE", response.data.data.balance);
                    });
            }
        },
        getModules({ commit, getters }, payload) {
            if (getters.getUserInfo && getters.getUserInfo.token) {
                axios
                    .get("module", {
                        headers: {
                            Authorization: `Bearer ${getters.getUserInfo.token}`
                        }
                    })
                    .then(response => {
                        commit("SET_ALL_MODULES", response.data.data);
                    });
            }
        }
    }
};
